enum  ElpLevel {
  ELP_1_3 = 'ELP 1-3',
  ELP_4_6 = 'ELP 4-6'
}

export { ElpLevel }
